module.exports = __webpack_public_path__ + "static/media/car.fa66ebba.svg";